// extracted by mini-css-extract-plugin
export default {"container":"A3MrpxYgCeALufSSLlgU","illustration":"TB1SPX879CgLUMJdNOqr","fill":"vRKyUnFotQAWxtqvCY6g"};